import { MILITAO_URL } from "@/config";

export const isOnboarding = (searchParams) => {
  return !!searchParams.get("priceId");
};

export const getCreateAccountPath = (searchParams) => {
  const path = "/create-account";
  if (!searchParams) return path;
  return `${path}?${searchParams.toString()}`;
};

export const getCheckoutPath = (searchParams) => {
  return `/checkout?${searchParams.toString()}`;
};

export const getWelcomeUrl = () => {
  return `${MILITAO_URL}/welcome`;
};

export const getCreateAccountUrl = (searchParams) => {
  return `${MILITAO_URL}${getCreateAccountPath(searchParams)}`;
};

export const getNextOnboardingStepHref = (
  searchParams,
  { skipCheckout = false } = {},
) => {
  const name = searchParams.get("name");
  const priceId = searchParams.get("priceId");

  if (!name || !priceId || priceId === "null") {
    return getCreateAccountPath(searchParams);
  }

  if (skipCheckout) return;
  return getCheckoutPath(searchParams);
};
